import { render } from "./ItemInfoDialog.vue?vue&type=template&id=4e1301c3&ts=true"
import script from "./ItemInfoDialog.vue?vue&type=script&lang=ts"
export * from "./ItemInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
